<div class="container w-100">
    <div class="row mt-0 row-container d-flex justiy-content-between">
        <div class="col-12 px-0">
            <h3>{{ 'companies_summary.sum' | translate }}</h3>
        </div>
        <div class="col-12 col-xl-6 pe-xl-2 px-0">
            <div *ngIf="company" class="company-info">
                <div class="logo">
                    <img
                        src="{{ company.logo ? company.logo : '../../../../../assets/icons/MOWA_logo.png' }}"
                        alt="Logo"
                    />
                </div>
                <div class="name">{{ company.name }}</div>
                <div class="info">{{ company.email }}</div>
                <div class="info">{{ company.phone }}</div>
                <div class="info">{{ company.website }}</div>
                <div class="info">{{ company.mowaId }}</div>
                <div class="info mb-3">{{ company.taxId }}</div>
                <div class="info">{{ company.country }}</div>
                <div class="info">{{ company.city }}</div>
                <div class="info">{{ company.street1 }}</div>
                <div class="w-100 text-center mt-5 button-container">
                    <button
                        (click)="goBack()"
                        class="btn btn-primary btn-xs-small m-3"
                    >
                     {{ 'user.btn_back' | translate }}
                    </button>
                    <button
                        (click)="editCompany()"
                        class="btn btn-primary btn-xs-small"
                    >
                        details
                    </button>
                </div>
            </div>
        </div>
        <div class="col-12 col-xl-6 ps-xl-2 px-0">
            <div class="mat-elevation-z2 names-container">
                <table
                    mat-table
                    [dataSource]="dataSource"
                    matSort
                    class="w-100 summary-table"
                >
                    <ng-container matColumnDef="firstName">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>
                            {{ 'home.name' | translate }}
                        </th>
                        <td mat-cell *matCellDef="let element">
                            {{element.firstName}}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="lastName">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>
                            {{ 'home.lastname' | translate }}
                        </th>
                        <td mat-cell *matCellDef="let element">
                            {{element.lastName}}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="role">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>
                            {{ 'home.role' | translate }}
                        </th>
                        <td mat-cell *matCellDef="let element">
                            <ng-container *ngFor="let role of roles">
                                {{ element.role === role.code ? role.name : ''
                                }}
                            </ng-container>
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="details">
                        <th
                            mat-header-cell
                            *matHeaderCellDef
                            mat-sort-header
                        ></th>
                        <td mat-cell *matCellDef="let element">
                            <button
                                class="btn btn-primary btn-xs-small float-right"
                                (click)="viewUser(element.id)"
                            >
                                details
                            </button>
                        </td>
                    </ng-container>
                    <!--
                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    -->
                    <tr
                        mat-row
                        *matRowDef="let row; columns: displayedColumns;"
                    ></tr>
                </table>
            </div>
        </div>
    </div>
</div>
<div class="modal-container" *ngIf="showModal">
    <div class="modal-content text-center">
        <div class="close-btn">
            <img src="../../../assets/icons/close.png" alt="" />
        </div>
        <h2>{{ 'response.super_user_header' | translate}}</h2>
        <h2>{{ 'response.super_user_header2' | translate}}</h2>
        <h2>{{ 'response.super_user_header3' | translate}}</h2>
        <button
            *ngFor="let user of superUserArr"
            class="btn btn-primary btn-xs-small float-right m-1"
            (click)="changeRoles(user)"
        >
        {{ user.email }}
        </button>
    </div>
</div>
